import "./styles.scss";

import React from "react";
import { Link } from "gatsby";
import clsx from "clsx";

const Badge = ({ url, label, variant }) => {
  const Type = url ? Link : "div";

  return (
    <Type className={clsx("badge", variant && `badge--${variant}`)} to={url}>
      {label}
    </Type>
  );
};

export default Badge;
